import React from 'react'
import { Box, useColor, Text } from '@myxplor/stardust'

const ErrorMessage = ({ children, ...props }) => {
  const safeColor = useColor('negative')
  return (
    <Box border={`solid 2px ${safeColor}`} paddingX="small" paddingY="medium" {...props}>
      <Text color="negative">{children}</Text>
    </Box>
  )
}

ErrorMessage.displayName = 'ErrorMessage'

export default ErrorMessage
